import supportedLocales from "@/config/supported-locales";
import { isNorwegianSite, isSwedishSite } from "@/utils/siteContext";

export function getSupportedLocales() {
  let annotatedLocales = [];
  const isNoDomain = isNorwegianSite();
  const isSeDomain = isSwedishSite();

  for (const code of Object.keys(supportedLocales)) {
    // For Norwegian domains (.no): show Norwegian, Swedish and English (hide Polish)
    if (isNoDomain && code === 'pl') {
      continue;
    }
    
    // For Swedish domains (.se): show only Swedish, English, and Polish (hide Norwegian)
    if (isSeDomain && code === 'no') {
      continue;
    }

    annotatedLocales.push({
      code,
      name: supportedLocales[code],
    });
  }

  return annotatedLocales;
}

export function supportedLocalesInclude(locale) {
  return Object.keys(supportedLocales).includes(locale);
}
